import React from 'react';

const plans = [
  {
    name: 'STARTER', price: '2500', mco: '400',
    desc: 'Idéal pour lancer votre présence en ligne rapidement.',
    popular: false,
    features: [
      { text: "Jusqu'à 5 pages", ok: true },
      { text: 'Design sur template personnalisé', ok: true },
      { text: 'Mobile responsive', ok: true },
      { text: 'SEO de base', ok: true },
      { text: 'Formulaire de contact', ok: true },
      { text: 'Hébergement 1 an inclus', ok: true },
      { text: 'SSL + nom de domaine', ok: true },
      { text: 'Système de réservation', ok: false },
      { text: 'Espace membres', ok: false },
      { text: 'E-commerce', ok: false },
    ],
    cta: 'Choisir Starter',
  },
  {
    name: 'PRO', price: '3500 – 5000', mco: '700',
    desc: 'Pour les pros qui veulent un site qui travaille pour eux.',
    popular: true,
    features: [
      { text: "Jusqu'à 12 pages", ok: true },
      { text: 'Design 100% sur-mesure', ok: true },
      { text: 'Mobile responsive', ok: true },
      { text: 'SEO avancé + blog', ok: true },
      { text: 'Réservation / rendez-vous', ok: true },
      { text: 'Hébergement 1 an inclus', ok: true },
      { text: 'SSL + nom de domaine', ok: true },
      { text: 'Google Analytics', ok: true },
      { text: 'Formation équipe (1h)', ok: true },
      { text: 'E-commerce full', ok: false },
    ],
    cta: 'Choisir Pro',
  },
  {
    name: 'PREMIUM', price: '7000 – 13000', mco: '1 000',
    desc: 'Solution complète pour les entreprises ambitieuses.',
    popular: false,
    features: [
      { text: 'Pages illimitées', ok: true },
      { text: 'Design premium exclusif', ok: true },
      { text: 'Mobile responsive', ok: true },
      { text: 'SEO expert + stratégie contenu', ok: true },
      { text: 'E-commerce complet', ok: true },
      { text: 'Espace membres', ok: true },
      { text: 'Hébergement 2 ans inclus', ok: true },
      { text: 'SSL + nom de domaine', ok: true },
      { text: 'Intégrations sur mesure', ok: true },
      { text: 'Support prioritaire 6 mois', ok: true },
    ],
    cta: 'Choisir Premium',
  },
];

export default function Pricing() {
  return (
    <section id="pricing" style={{
      background: '#0d0d14', padding: '7rem 2rem',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <p style={{
            color: '#7C3AED', fontWeight: 600, fontSize: 12,
            letterSpacing: '0.15em', textTransform: 'uppercase',
            marginBottom: '1rem',
          }}>TARIFICATION</p>
          <h2 style={{
            fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 800,
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            lineHeight: 1.1, letterSpacing: '-0.02em',
          }}>
            Des prix <span style={{ color: '#A78BFA' }}>transparents</span>
          </h2>
          <p style={{ color: '#8b8b9a', marginTop: '1rem', fontSize: 16 }}>
            Tout est inclus. Pas de mauvaises surprises. Paiement en MAD, facturation locale.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '1.5rem', alignItems: 'start',
        }}>
          {plans.map((p, i) => (
            <div key={i} style={{
              background: p.popular ? 'rgba(61,26,110,0.4)' : '#13131d',
              border: p.popular ? '2px solid #7C3AED' : '1px solid rgba(255,255,255,0.07)',
              borderRadius: 20, padding: '2rem',
              position: 'relative',
              transition: 'transform 0.3s',
            }}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-4px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
            >
              {p.popular && (
                <div style={{
                  position: 'absolute', top: -14, left: '50%',
                  transform: 'translateX(-50%)',
                  background: '#7C3AED', color: '#fff',
                  fontSize: 12, fontWeight: 700,
                  fontFamily: 'Plus Jakarta Sans, sans-serif',
                  padding: '4px 16px', borderRadius: 20,
                  whiteSpace: 'nowrap',
                }}>Le plus populaire</div>
              )}

              <p style={{
                fontSize: 12, fontWeight: 600, letterSpacing: '0.1em',
                color: '#8b8b9a', marginBottom: '1rem',
              }}>{p.name}</p>

              <div style={{ marginBottom: '0.5rem' }}>
                <span style={{
                  fontFamily: 'Plus Jakarta Sans, sans-serif',
                  fontSize: 'clamp(1.8rem, 4vw, 2.4rem)',
                  fontWeight: 800,
                }}>{p.price}</span>
                <span style={{ color: '#8b8b9a', fontSize: 16, marginLeft: 6 }}>MAD</span>
              </div>
              <p style={{ color: '#A78BFA', fontSize: 13, marginBottom: '1rem' }}>
                + <strong>{p.mco} MAD/mois</strong> MCO
              </p>
              <p style={{ color: '#8b8b9a', fontSize: 14, marginBottom: '1.5rem', lineHeight: 1.6 }}>
                {p.desc}
              </p>

              <div style={{ borderTop: '1px solid rgba(255,255,255,0.07)', paddingTop: '1.5rem', marginBottom: '1.5rem' }}>
                {p.features.map((f, j) => (
                  <div key={j} style={{
                    display: 'flex', alignItems: 'center', gap: 10,
                    marginBottom: '0.6rem',
                  }}>
                    <span style={{ color: f.ok ? '#7C3AED' : '#3a3a4a', fontSize: 16, flexShrink: 0 }}>
                      {f.ok ? '✓' : '○'}
                    </span>
                    <span style={{
                      fontSize: 14, color: f.ok ? '#c4c4d0' : '#4a4a5a',
                      textDecoration: f.ok ? 'none' : 'line-through',
                    }}>{f.text}</span>
                  </div>
                ))}
              </div>

              <a href="#contact" style={{
                display: 'block', textAlign: 'center',
                padding: '13px', borderRadius: 10,
                textDecoration: 'none', fontWeight: 600,
                fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 15,
                transition: 'all 0.2s',
                background: p.popular ? '#7C3AED' : 'transparent',
                color: p.popular ? '#fff' : '#c4c4d0',
                border: p.popular ? 'none' : '1px solid rgba(255,255,255,0.15)',
              }}
                onMouseEnter={e => {
                  if (p.popular) e.currentTarget.style.background = '#6D28D9';
                  else e.currentTarget.style.borderColor = '#7C3AED';
                }}
                onMouseLeave={e => {
                  if (p.popular) e.currentTarget.style.background = '#7C3AED';
                  else e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)';
                }}
              >{p.cta}</a>
            </div>
          ))}
        </div>

        <p style={{
          textAlign: 'center', color: '#4a4a5a',
          fontSize: 13, marginTop: '2rem',
        }}>
          Tous les prix sont HT · MCO = Maintenance, Content & Opérations mensuel ·{' '}
          <a href="#contact" style={{ color: '#7C3AED', textDecoration: 'none' }}>
            Devis personnalisé disponible
          </a>
        </p>
      </div>
    </section>
  );
}
